import React, { useState } from 'react';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { convertDate } from 'utils/commonHelpers';

const EditScriptDialog = ({ onClose, onCloseCancel, data }) => {
    const [scriptName, setScriptName] = useState(data.name);
    const [scriptDescription, setScriptDescription] = useState(data.description);
    const [fileName, setFileName] = useState(data.file);
    const [updatedDate, setUpdatedDate] = useState(data.updated);

    const handleSubmit = () => {
        ApiHelper.put(`/api/server/scripts/${data.id}/`, {
            name: scriptName,
            description: scriptDescription,
            file_name: fileName,
            updated_date: convertDate(updatedDate)
        })
            .then(() => {
                toast.success('Successfully updated');
                onClose();
            })
            .catch(() => {
                toast.error('Failed to edit the script');
            });
    };

    return (
        <Dialog open={true} onClose={onCloseCancel}>
            <DialogTitle sx={{ fontSize: '16px' }}>Edit Script</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Name"
                        value={scriptName}
                        onChange={(e) => setScriptName(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Description"
                        value={scriptDescription}
                        onChange={(e) => setScriptDescription(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="File Name"
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Updated Date"
                            value={updatedDate}
                            onChange={(newValue) => {
                                setUpdatedDate(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseCancel}>Cancel</Button>
                <Button onClick={handleSubmit} variant="outlined">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EditScriptDialog.propTypes = {
    onClose: PropTypes.func,
    onCloseCancel: PropTypes.func,
    data: PropTypes.object
};

export default EditScriptDialog;
